import { put, takeLatest } from 'redux-saga/effects';
import httpClient from 'utils/http-client';
import { handleError } from 'utils/utils';
import { getStudentTraitAssessmentFail, getStudentTraitAssessmentSuccess } from '../actions';
import configActionTypes from '../types';

export function* getStudentTraitAssessment({ payload }) {
  try {
    const response = yield httpClient.get(`/student-trait-assessments`, { params: payload });
    yield put(getStudentTraitAssessmentSuccess(response.data, payload.traitGroupId));
  } catch (error) {
    yield put(getStudentTraitAssessmentFail(error?.message));
    const err = handleError(error);
  }
}

export function* onGetStudentTraitAssessment() {
  yield takeLatest(configActionTypes.GET_STUDENT_TRAIT_ASSESSMENT_START, getStudentTraitAssessment);
}
